<!-- Google SSO -->
@if(enableGoogleSSO) {
<ng-container>
  @if(parentForm.formStates.gsi) {<span
    class="flex flex-col items-center gap-1"
  >
    <mat-spinner></mat-spinner>
    <p>Loading Google SSO</p>
  </span>
  }
  <div id="googleButtonDiv"></div>
  @if(!parentForm.formStates.gsi && !googleLoad) {<span
    class="flex flex-col items-center gap-1"
  >
    Reload To Use Google SSO
  </span>
  }
</ng-container>
}
